import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';
import { ICourse } from '../CoursesSlice';

const apiDataProvider = new APIDataProvider();

const startPremiumTrial = createAsyncThunk('/premium/trial', async () => {
  const path = `${ApiPaths.premium}/trial`;
  const response = await apiDataProvider.post<TApiResponse<ICourse>>(path, {});

  return response.data;
});

export default startPremiumTrial;
